import mixpanel from 'mixpanel-browser'

const track = (eventName, props = {}) => {
  if (window.App.web_config.test_mode) return

  try {
    mixpanel.get_distinct_id()
  } catch (e) {
    mixpanel.init(window.App.web_config.mixpanel_token)
  }

  createEvent(eventName, props)
}

const createEvent = (eventName, props) => {
  switch (eventName) {
    case 'Page View':
      mixpanel.track_pageview({'page': props.page})
      break
    case 'Create Reservation':
    case 'Sign In':
    case 'Charge POS':
    case 'Run Report':
      mixpanel.track(eventName, props)
      break
    case 'Open Client Info':
    case 'Add Client':
      mixpanel.track(eventName)
      break
  }
}

const signIn = (userId, userDetails) => {
  if (window.App.web_config.test_mode || userDetails == null) return

  mixpanel.init(window.App.web_config.mixpanel_token)

  if (userId == mixpanel.get_distinct_id()) return

  mixpanel.identify(userId)
  mixpanel.people.set(userDetails)

  createEvent('Sign In', userDetails)
}

const signOut = () => {
  if (window.App.web_config.test_mode) return

  try {
    mixpanel.get_distinct_id()
  } catch (e) {
    mixpanel.init(window.App.web_config.mixpanel_token)
  }

  mixpanel.reset()
}

export default track
export { signIn, signOut }
